import { computed } from 'mobx';
import { getOmnistore } from '../stores/Omnistore';
import { dbPromise } from './DbPromise';

class DbSvc {
	@computed get reoctoStore() {
		return getOmnistore().reoctoStore;
	}

	fetch({id, entityClassName, masterId}) {
		function toIndexName(entityClassName) {
			switch (entityClassName) {
			case 'SpecialOffer': return 'supplierId';
			default: return entityClassName.replace(/Item$/, '').toLowerCase() + 'Id';
			}
		}

		return dbPromise().then(db => {try {
			const tx = db.transaction([entityClassName, 'meta']);
			const etag = tx.objectStore('meta').get(id).then(nv => nv ? nv.etag : '');
			let list;
      console.log("entity("+entityClassName+"):masterId:",masterId+",indexNames:",tx.objectStore(entityClassName).indexNames);
			if (masterId) {
				list = tx.objectStore(entityClassName).index(toIndexName(entityClassName)).getAll(masterId);
			} else {
				list = tx.objectStore(entityClassName).getAll();
			}
			return Promise.all([etag, list])
				.then(([etag, list]) => ({etag, list}));
		} catch (e) {
			console.error('fetching', id, e);
			throw e;
		}});
	}

	async patch({id, entityClassName}, etag, patches) {
		if (!this.reoctoStore.useDb) return;

		const db = await dbPromise();
		console.log('patch', id, entityClassName);
		const tx = db.transaction([entityClassName, 'meta'], 'readwrite');
		tx.objectStore('meta').put({id, etag});
		const store = tx.objectStore(entityClassName);
		for (let p of patches) {
			//console.log(p.op, p.path)
			if (p.op === 'remove') {
				store.delete(p.path.substring(1));
			} else {
				store.put(p.value);
			}
		}
	}
}

export const dbSvc = new DbSvc();
